/**
 * role-landing.ts — a qué universo se manda a alguien al arrancar la app.
 *
 * QUÉ RESUELVE: un profesor no debe aterrizar en el mapa del alumno y un admin
 * quiere su panel. Eso se decide antes de montar React, con el rol del JWT y
 * sin coste de base.
 *
 * EL FALLO QUE CORRIGE (30/08/2026): la regla era «si eres admin y el hash no
 * dice "admin", vete a #/admin», y se evaluaba en CADA arranque. O sea, un
 * admin no podía abrir ni un solo enlace directo: pegabas
 * `#/lesson/<id>/video?role=bet`, la app arrancaba, veía tu rol y te borraba la
 * URL. Probar el segundo vídeo de una unidad era imposible por esa vía, y lo
 * mismo cualquier enlace que alguien te pasara.
 *
 * LA REGLA BUENA: el redirect es para quien llega SIN pedir nada —recién
 * iniciada la sesión, o entrando a pelo—. Si escribió una ruta, esa ruta manda.
 * Quien pide un sitio ya ha dicho a dónde quiere ir.
 *
 * Y se compara la ruta entera, no `includes`: con el criterio viejo una lección
 * llamada `/lesson/administracion/video` contenía "admin" y se daba por buena
 * de casualidad.
 *
 * Lógica pura: sin DOM, sin red, sin React.
 */

/** Hashes que significan "no he pedido ningún sitio". */
const LANDING_HASHES = ['', '/', '/login'];

const HOME_BY_ROLE: Record<string, string> = {
    admin: '#/admin',
    super_admin: '#/admin',
    teacher: '#/teacher',
};

/**
 * El hash al que llevar a alguien, o `null` para dejarlo donde está.
 *
 * @param rawHash `window.location.hash` sin la almohadilla inicial.
 * @param userRole El rol del JWT.
 */
export function roleLandingHash(
    rawHash: string,
    userRole: string | null | undefined,
): string | null {
    const home = HOME_BY_ROLE[userRole ?? ''];
    if (home === undefined) return null;

    const asked = rawHash.replace(/^#/, '');
    if (!LANDING_HASHES.includes(asked)) return null;

    return home;
}
